module.exports = (function(window, document, undefined) {

  var form = document.getElementById('gform_4');
  var thankYou = document.querySelector('.thank-you--section');
  var formValidationErrors = document.querySelector('.gfield_validation_message');

  function init() {

    if (formValidationErrors){
      return;
    }

    if (!thankYou) {
      return;
    }

    var btn = document.getElementById('gform_submit_button_4');
    if(btn){
      btn.addEventListener('click', function(){
        localStorage.setItem('form', 'submitted');
        localStorage.setItem('eppFormTrack', 'true');
      })
    }

    window.addEventListener('load', (event) => {
      if (localStorage.getItem('form') === 'submitted') {
        thankYou.classList.remove('u-display-none');
      }

      if (localStorage.getItem('eppFormTrack') === 'true') {
          //tracking on successful submission
           window.dataLayer = window.dataLayer || [];
           dataLayer.push({
            'event' : 'GAEvent',
            'eventCategory' : 'form',
            'eventAction' : 'submission',
            'eventLabel' : 'epp'
          });

         //only track once
         localStorage.removeItem('eppFormTrack');
      }
    })

  }
  return {
    init: init
  };

})(window, document);
